<template>
  <div class="row">
    <div class="col-12">
      <Heading>Flaschen</Heading>
      <div>
        <router-link class="btn btn-primary btn-sm px-5 mb-5" to="/admin/bottles/add/new">
          <i class="fas fa-plus pr-4"></i>Flasche anlegen
        </router-link>
      </div>
      <SearchBar v-model="searchQuery"
                 placeholder="Suche nach Flaschennummer / Flaschenart / Ablaufdatum">
        <template v-slot:filter="">
          <div>
            Fällig:<br>
            <input type="radio" value="-1" v-model.number="filter.date" id="filter0"/> <label
              for="filter0">alle</label>
          </div>
          <div>
            <input type="radio" value="7" v-model.number="filter.date" id="filter1"/> <label for="filter1">weniger
            als 7 Tage</label>
          </div>
          <div>
            <input type="radio" value="31" v-model.number="filter.date" id="filter2"/> <label for="filter2">weniger
            als 1 Monat</label>
          </div>
        </template>
      </SearchBar>
      <span class="text-primary mb-3 d-inline-block">{{ queryFilteredBottles.length }} Treffer</span>

      <list :items="queryFilteredBottles" :sort-key="sort.key" :sort-asc="sort.asc">
        <template v-slot:header>
          <div class="row">
            <div class="col-4" style="cursor: pointer;" @click="setSortProps('serial')">
              Flaschen Nummer
              <i v-if="sort.key === 'serial' && sort.asc" class="fas fa-chevron-up"></i>
              <i v-else-if="sort.key === 'serial' && !sort.asc" class="fas fa-chevron-down"></i>
            </div>
            <div class="col">
              Status / Letzte Aktion
              <i v-if="sort.key === '' && sort.asc" class="fas fa-chevron-up"></i>
              <i v-else-if="sort.key === '' && !sort.asc" class="fas fa-chevron-down"></i>
            </div>
          </div>
        </template>
        <template v-slot:itemTemplate="{item}">
          <div class="row align-items-center py-1">
            <!--						 <div class="col-12">{{item}}</div>-->
            <div class="col-4">
              Nr. {{ item.serial }}
            </div>
            <div class="col">
              <bottle-state :item="item"/>
            </div>
            <div class="col-1 text-right">
              <button class="btn" @click="$router.push('/admin/bottles/'+item.id)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </template>
      </list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapActions, mapState} from "vuex";

import Navigation from "../../components/admin/Navigation";
import List from "../../components/admin/List";
import SearchBar from "../../components/admin/SearchBar";
import Heading from "../../components/admin/Heading";
import BottleState from "../../components/admin/BottleState";
import timeFormatter from "../../mixins/timeFormatter";
import moment from 'moment';

export default {
  name: "BottleList",
  components: {BottleState, List, Navigation, Heading, SearchBar},
  mixins: [timeFormatter],
  data() {
    return {
      searchQuery: "",
      sort: {
        key: 'serial',
        asc: true
      },
      filter: {
        date: -1
      }
    }
  },
  computed: {
    ...mapState({
      bottles: state => state.Api.Bottles.all
    }),
    filteredBottles() {
      let nowMoment = moment().add(this.filter.date, 'd');

      return this.bottles.filter(el => {
        if (this.filter.date === -1) {
          return true
        }

        let dueMoment = moment(el.due);
        return nowMoment.unix() > dueMoment.unix()

      })
    },
    queryRegex() {
      return this.searchQuery.toLocaleLowerCase().replace(' ', '.*')
    },
    queryFilteredBottles() {
      return this.filteredBottles.filter(el => {
        let matchSerial = el.serial.match(this.queryRegex);
        let type = el.type || "";
        let matchType = type.toLocaleLowerCase().match(this.queryRegex);
        let matchDate = this.dateWithFormat(el.due).match(this.queryRegex);

        return (matchSerial && matchSerial.length > 0) || (matchType && matchType.length > 0) || (matchDate && matchDate.length > 0);
      })
    },
  },
  mounted() {
    this.refreshBottles()
  },
  methods: {
    ...mapActions({
      refreshBottles: "Api/Bottles/all"
    }),
    setSortProps(key) {
      Vue.set(this.sort, 'key', key);
      Vue.set(this.sort, 'asc', !this.sort.asc);
    }
  },
}
</script>

<style scoped>

</style>
